import { render, staticRenderFns } from "./TodayResult.vue?vue&type=template&id=494f7d57&scoped=true&"
import script from "./TodayResult.vue?vue&type=script&lang=js&"
export * from "./TodayResult.vue?vue&type=script&lang=js&"
import style0 from "./TodayResult.vue?vue&type=style&index=0&id=494f7d57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f7d57",
  null
  
)

export default component.exports